const o=["size","voltage"],c=["color"],e=["color"],l=[1,1.5,2],r="BRL";export{l as DEFAULT_IMG_RESOLUTIONS,r as NATIONAL_CURRENCY,e as PRODUCT_ATTR_HIDE_WITHOUT_VARIATION,o as PRODUCT_ATTR_MANDATORY,c as PRODUCT_ATTR_SORT_BY_AVAILABILITY};
